var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "md-layout" },
      [
        _vm.adjustmentDetails.isEditing === false
          ? _c("adjustment-create-new-Component", {
              attrs: {
                "adjustment-details": _vm.adjustmentDetails,
                "team-members": _vm.teamMembers,
                customers: _vm.customers,
              },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50 tripdate-container" },
          [
            _c(
              "md-datepicker",
              {
                attrs: { "md-immediately": "", "md-debounce": 10 },
                model: {
                  value: _vm.adjustmentDetails.tripDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.adjustmentDetails, "tripDate", $$v)
                  },
                  expression: "adjustmentDetails.tripDate",
                },
              },
              [_c("label", [_vm._v("Adjustment Date")])]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50 amount-container" },
          [
            _c(
              "div",
              { staticClass: "amount-switch-container custom-switch-blue" },
              [
                _c("md-switch", {
                  staticClass: "amount-switch",
                  on: { change: _vm.handlePercentageChange },
                  model: {
                    value: _vm.adjustmentDetails.adjustmentIsPercentage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.adjustmentDetails,
                        "adjustmentIsPercentage",
                        $$v
                      )
                    },
                    expression: "adjustmentDetails.adjustmentIsPercentage",
                  },
                }),
              ],
              1
            ),
            _c(
              "form-group",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.adjustmentDetails.adjustmentIsPercentage,
                    expression: "!adjustmentDetails.adjustmentIsPercentage",
                  },
                ],
                attrs: { name: "amount", label: "Amount", attribute: "Amount" },
              },
              [
                _vm.adjustmentDetails.amount
                  ? _c("span", { staticClass: "currency-container" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("currency")(
                              null,
                              _vm.user.teamCurrency,
                              true
                            )
                          ) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _c("md-input", {
                  attrs: { required: "", type: "number" },
                  model: {
                    value: _vm.adjustmentDetails.amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "amount", _vm._n($$v))
                    },
                    expression: "adjustmentDetails.amount",
                  },
                }),
              ],
              1
            ),
            _c(
              "form-group",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.adjustmentDetails.adjustmentIsPercentage,
                    expression: "adjustmentDetails.adjustmentIsPercentage",
                  },
                ],
                attrs: {
                  name: "percentageAmount",
                  label: "Percentage",
                  attribute: "Percentage",
                },
              },
              [
                _c("md-input", {
                  attrs: { required: "", type: "number" },
                  model: {
                    value: _vm.adjustmentDetails.percentageAmount,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.adjustmentDetails,
                        "percentageAmount",
                        _vm._n($$v)
                      )
                    },
                    expression: "adjustmentDetails.percentageAmount",
                  },
                }),
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("invoicing.adjustments.percentageTooltip"))
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50" },
          [
            _c(
              "form-group",
              {
                attrs: {
                  name: "invoiceAdjustmentCategory",
                  label: "Category",
                  attribute: "Category",
                },
              },
              [
                _c("md-input", {
                  attrs: { type: "hidden" },
                  model: {
                    value: _vm.adjustmentDetails.invoiceAdjustmentCategory,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.adjustmentDetails,
                        "invoiceAdjustmentCategory",
                        $$v
                      )
                    },
                    expression: "adjustmentDetails.invoiceAdjustmentCategory",
                  },
                }),
                _c("vue-select", {
                  attrs: {
                    label: "category",
                    options: _vm.categoryList,
                    "append-to-body": true,
                  },
                  model: {
                    value: _vm.adjustmentDetails.invoiceAdjustmentCategory,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.adjustmentDetails,
                        "invoiceAdjustmentCategory",
                        $$v
                      )
                    },
                    expression: "adjustmentDetails.invoiceAdjustmentCategory",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50" },
          [
            _c(
              "form-group",
              {
                attrs: {
                  name: "description",
                  label: "Description",
                  attribute: "Description",
                },
              },
              [
                _c("md-input", {
                  model: {
                    value: _vm.adjustmentDetails.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.adjustmentDetails, "description", $$v)
                    },
                    expression: "adjustmentDetails.description",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-size-100 account-code-description-container",
          },
          [
            _c("account-code-description-group", {
              attrs: {
                "account-code": _vm.adjustmentDetails.accountCode,
                "account-code-description":
                  _vm.adjustmentDetails.accountCodeDescription,
                "is-update": true,
                "account-code-type": _vm.accountCodeType,
                "account-code-container-class": "md-layout-item md-size-50",
                "account-code-description-container-class":
                  "md-layout-item md-size-50",
                "parent-container-class": "md-layout",
              },
              on: {
                optionSelected: _vm.handleAccountCodeChanged,
                optionDescriptionSelected: _vm.handleAccountDescriptionChanged,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }